import React from 'react';
import { Card } from 'primereact/card';
import UnMappedFields from 'modules/lead/AddLead/components/CaseInformation/UnMappedFields';

const CaseDetailsUnmappedFields = ({ field, control, setValue, watch, errors }) => {
  const onlineLeadFields = watch('online_lead_fields');
  const hasAnsweredField = onlineLeadFields?.some(
    (field) =>
      field &&
      ((field.value !== undefined && field?.value !== '' && (!Array.isArray(field.value) || field.value?.length > 0)) ||
        (field.type === 'time' && field.time !== undefined))
  );

  return onlineLeadFields != null ? (
    hasAnsweredField ? (
      <>
        <div className="d-flex justify-content-between ">
          <div className="caption-bold mb-2 mt-3">ONLINE FORM ANSWERS</div>
        </div>
        <Card className="mb-4 card-bg">
          <UnMappedFields field={field} control={control} setValue={setValue} errors={errors} />
        </Card>
      </>
    ) : onlineLeadFields?.length === 0 ? (
      <div className="row mb-2">
        <div className="col-12 small">
          <i className="fas fa-info-circle mx-2 mt-1"></i>
          <span className="text-hint">No Unmapped Fields Found.</span>
        </div>
      </div>
    ) : (
      <div className="row mb-2">
        <div className="col-12 small">
          <i className="fas fa-info-circle mx-2 mt-1"></i>
          <span className="text-hint">No Answered Unmapped Fields Found.</span>{' '}
        </div>
      </div>
    )
  ) : null;
};

export default CaseDetailsUnmappedFields;
